/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const r=()=>({style:{},transform:{},transformOrigin:{},vars:{}});export{r as createHtmlRenderState};
//# sourceMappingURL=create-render-state.js.map
